<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import OffersList from "./offres";
import SuppliersApi from "@/services/suppliers-api";


/**
 * Projects-list component
 */
export default {
  page: {
    title: "Liste des Offres",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,  OffersList },
  data() {
    return {
      daterange: null,
      suppliersList:[],
      selected:null,
      selectedSupplier:null,
      before:null,
      after:null,
      start:null,
      end:null,

    };
  },

  mounted(){
    this.getSuppliers()
  },

  methods :{
    getSuppliers(){
      SuppliersApi.getAllSuppliers(true).then(
        response => {
          this.suppliersList=response;
        }
      )
    }

  },

  watch: {
        selected: function() {
            this.selectedSupplier = this.selected ? this.selected.id : null
        },
        end: function(){
          this.before = this.end? this.end : null
        },
        start: function(){
          this.after  = this.start? this.start : null
        }
    }
};
</script>
<template>
  <Layout>
    <div class="row  pt-4">
      <div class="col-lg-12">
        <div class="card border border-primary">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Offres Groupées</h2>
            <p class="card-title-desc font-size-14">
              Rechercher des offres par fournisseur.
            </p>
                <div class="row mt-2">
                  <div class="col-sm-5 col-xs-6">
                    <b-form-group label="Fournisseur" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="suppliersList" placeholder="Fournisseur" label="name" v-model="selected">
                        <span slot="no-options">Aucun fournisseur dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                  <div class="col-sm-1 col-xs-0"/>

                  <!-- <div class="col-sm-3 col-xs-12 pr-sm-2">
                    <b-form-group label="Date Début" label-for="">
                      <b-form-datepicker
                        v-model="start"
                        locale="fr"
                        label-no-date-selected="Date Début"
                        dark
                        reset-button
                        close-button
                        label-reset-button="Réinitialiser"
                        label-close-button="Fermer"
                        dropright
                        hide-header
                      ></b-form-datepicker>
                    </b-form-group>
                  </div> -->
                  <!-- <div class="col-sm-3 col-xs-12">
                    <b-form-group label="Date Fin" label-for="">
                      <b-form-datepicker
                        v-model="end"
                        locale="fr"
                        label-no-date-selected="Date Fin"
                        dark
                        reset-button
                        close-button
                        label-reset-button="Réinitialiser"
                        label-close-button="Fermer"
                        dropright                         
                        hide-header
                      ></b-form-datepicker>
                    </b-form-group>
                  </div> -->
                </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row pt-4 pb-4">
      <div class="col-lg-12">
          <OffersList :selectedSupplier.sync=this.selectedSupplier :before.sync=this.before :after.sync=this.after :isGroupedPromotions=true />
      </div>
    </div>
   
  </Layout>
</template>